import React, { ReactNode } from "react";
import Header from "./header";
import Footer from "./footer";
import FilterMenu from "../results/filtermenu";

interface SearchLayoutProps {
  children: ReactNode;
  showFilterMenu?: boolean;
  containerClassName?: string;
  showResultsContainer?: boolean;
}

const SearchLayout = ({
  children,
  showFilterMenu = true,
  containerClassName = "all-results-container",
  showResultsContainer = true,
}: SearchLayoutProps) => {
  return (
    <div className="main" style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <a href="#main-content" className="skip-to-content">Skip to content</a>
      <Header />
      {showFilterMenu && <FilterMenu />}
      {showResultsContainer ? (
        <div id="main-content" className={containerClassName} style={{ flex: 1 }}>{children}</div>
      ) : (
        <div id="main-content" style={{ flex: 1 }}>{children}</div>
      )}
      <Footer />
    </div>
  );
};

export default SearchLayout;
